<div class="flex flex-col items-center justify-center h-screen  mx-5 md:mx-0">
    <p-toast></p-toast>
    <div class="flex flex-col items-center justify-center border border-gray-200 rounded-lg p-10 w-full max-w-[450px]">
        <img src="assets/logo.png" alt="Office Global Logo" class=" h-[60px] object-contain">
        <h1 class="text-2xl font-bold mt-2">Reset Password</h1>
        <p class="text-base text-gray-500 mt-2">Setup a new password for your account</p>

        <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" class="w-full">
            <div class="w-full flex flex-col gap-2 mt-5">
                <div class="w-full flex items-center justify-start">
                    <label class="text-start" for="newPassword">New Password <span class="text-red-500">*</span></label>
                </div>
                <p-password fluid formControlName="newPassword" [toggleMask]="true" placeholder="••••••••" [feedback]="false" autocomplete="new-password">
                    <ng-template pTemplate="header">
                        <i class="pi pi-lock text-gray-500"></i>
                    </ng-template>
                </p-password>
                <small class="text-gray-500 text-sm mt-1">
                  Password must be at least 8 characters long, contain at least one lowercase letter, one uppercase letter, one digit, and one special character (e.g., @, #, $, _, etc.).
                </small>

                <!-- Password Strength Indicator -->
                <div class="mt-2" *ngIf="resetPasswordForm.get('newPassword')?.value">
                    <div class="flex items-center gap-2 mb-1">
                        <span class="text-xs text-gray-600">Strength:</span>
                        <span class="text-xs font-medium" [class]="getCurrentPasswordStrength().color === 'bg-red-500' ? 'text-red-600' : getCurrentPasswordStrength().color === 'bg-yellow-500' ? 'text-yellow-600' : getCurrentPasswordStrength().color === 'bg-blue-500' ? 'text-blue-600' : 'text-green-600'">
                            {{ getCurrentPasswordStrength().label }}
                        </span>
                    </div>
                    <div class="flex gap-1">
                        <div *ngFor="let i of [1,2,3,4,5]" class="h-1 flex-1 rounded transition-all duration-200" [class]="i <= getCurrentPasswordStrength().score ? getCurrentPasswordStrength().color : 'bg-gray-200'">
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-full flex flex-col gap-2 my-5">
                <div class="w-full flex items-center justify-start">
                    <label class="text-start" for="confirmPassword">Confirm Password <span class="text-red-500">*</span></label>
                </div>
                <p-password fluid formControlName="confirmPassword" [toggleMask]="true" placeholder="••••••••" [feedback]="false" autocomplete="new-password">
                    <ng-template pTemplate="header">
                        <i class="pi pi-lock text-gray-500"></i>
                    </ng-template>
                </p-password>
                <small class="text-red-500 text-sm mt-1" *ngIf="getConfirmPasswordError()">
                    {{ getConfirmPasswordError() }}
                </small>
            </div>

            <p-button 
                label="Reset Password" 
                class="w-full !w-full" 
                type="submit" 
                [disabled]="resetPasswordForm.invalid || isLoading"
                [loading]="isLoading">
            </p-button>
        </form>
    </div>
</div>